import { environment } from '@env/environment';
import { InternalIcon } from '@shared/enums/internal-icon.enum';
import { NavInterface } from '@shared/interfaces/nav.interface';

export const navs: NavInterface[] = [
  {
    route: environment.jipUrl.startPage,
    name: 'StartPage.NavItem.Start',
    ngIcon: 'matFlag',
  },
  {
    route: '/challenges',
    name: 'Calls & Challenges',
    ngIcon: 'matLightbulb',
    minWidth: 115,
  },
  {
    route: '/ventures',
    name: 'Ideas & Ventures',
    jipIcon: InternalIcon.Unicorn,
    minWidth: 78,
  },
  { route: '/people', name: 'Network', ngIcon: 'matPeopleAlt' },
  { route: '/events', name: 'Events', ngIcon: 'matEventAvailable' },
  {
    route: '/organizations',
    name: 'Organizations',
    ngIcon: 'matHub',
  },
];
